var _templateObject;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { useTheme } from "../../../lib/hooks";
import { cn } from "../../../lib/utils";
import { injectGlobal } from '@emotion/css';
import React from 'react';
import { Image } from "../image";
import * as styles from "./empty";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var _styles = injectGlobal(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n.moly-empty {\n  font-family: var(--bds-font-family);\n  .moly-empty-title {\n    margin-top:16px;\n  }\n}\n\n.moly-empty-image {\n  img {\n    height: 100%;\n  }\n}\n\n.moly-empty-large {\n  .moly-btn {\n    min-width: 188px;\n  }\n  .moly-empty-image {\n    height: 120px;\n  }\n  .moly-empty-subtitle{\n    margin-top: 8px;\n  }\n}\n\n.moly-empty-medium {\n  .moly-btn {\n    min-width: 130px;\n  }\n\n  .moly-empty-image {\n    height: 120px;\n  }\n\n  .moly-empty-subtitle{\n    margin-top: 4px;\n  }\n}\n\n.moly-empty-small {\n  .moly-empty-image {\n    height: 90px;\n  }\n\n  .moly-empty-subtitle{\n    margin-top: 0px;\n  }\n}\n"])));
var Empty = function Empty(props) {
  var image = props.image,
    imageStyle = props.imageStyle,
    className = props.className,
    style = props.style,
    children = props.children,
    title = props.title,
    subTitle = props.subTitle,
    extra = props.extra,
    _props$size = props.size,
    size = _props$size === void 0 ? 'large' : _props$size,
    _props$status = props.status,
    status = _props$status === void 0 ? 'noData' : _props$status,
    theme = props.theme;
  var width = size !== 'small' ? 160 : 120;
  var _useTheme = useTheme(),
    _useTheme2 = _slicedToArray(_useTheme, 1),
    color = _useTheme2[0];
  var realTheme = theme || color;
  var EMPTY_STYLE = {
    light: {
      noData: /*#__PURE__*/_jsx(Image, {
        src: "https://s1.bycsi.com/bybit/deadpool/image-753b8f8574e14122b16bb109f8cac606.svg",
        alt: "noData",
        width: width
      }),
      noSearchResult: /*#__PURE__*/_jsx(Image, {
        src: "https://s1.bycsi.com/bybit/deadpool/image-6ada0380d35943e0b6ff16e2b73fb41f.svg",
        alt: "noSearchResult",
        width: width
      }),
      databaseError: /*#__PURE__*/_jsx(Image, {
        src: "https://s1.bycsi.com/bybit/deadpool/image-436b6f94d7d54763a29d53bd4d091ab9.svg",
        alt: "databaseError",
        width: width
      }),
      networkError: /*#__PURE__*/_jsx(Image, {
        src: "https://s1.bycsi.com/bybit/deadpool/image-f536ecc64c7e4e84bd5ebed90d00f7c8.svg",
        alt: "networkError",
        width: width
      })
    },
    dark: {
      noData: /*#__PURE__*/_jsx(Image, {
        src: "https://s1.bycsi.com/bybit/deadpool/image-5aee707461684b3386f5974665bbc449.svg",
        alt: "noData",
        width: width
      }),
      noSearchResult: /*#__PURE__*/_jsx(Image, {
        src: "https://s1.bycsi.com/bybit/deadpool/image-96d75d0c274b419aa999c026a272ca53.svg",
        alt: "noSearchResult",
        width: width
      }),
      databaseError: /*#__PURE__*/_jsx(Image, {
        src: "https://s1.bycsi.com/bybit/deadpool/image-01638283da294c6081d53e8105642e9a.svg",
        alt: "databaseError",
        width: width
      }),
      networkError: /*#__PURE__*/_jsx(Image, {
        src: "https://s1.bycsi.com/bybit/deadpool/image-f91bf0d0b23445ada4bf5d5ac5204d7e.svg",
        alt: "networkError",
        width: width
      })
    },
    title: {
      large: styles.molyText18,
      medium: styles.molyText16,
      small: styles.molyText14
    },
    subTitle: {
      large: styles.molyText16,
      medium: styles.molyText14,
      small: styles.molyText12
    },
    extra: {
      large: styles.molyMargin32,
      medium: styles.molyMargin20,
      small: styles.molyMargin16
    }
  };
  var ExceptionStatus = Object.keys(EMPTY_STYLE['light']);
  var imageNode = null;
  var des = title || subTitle;
  var alt = typeof des === 'string' ? des : 'empty';
  if (typeof image === 'string') {
    imageNode = /*#__PURE__*/_jsx("img", {
      alt: alt,
      src: image
    });
  } else if (image) {
    imageNode = image;
  } else if (ExceptionStatus.includes("".concat(status))) {
    var _EMPTY_STYLE;
    var SVGComponent = (_EMPTY_STYLE = EMPTY_STYLE[realTheme]) === null || _EMPTY_STYLE === void 0 ? void 0 : _EMPTY_STYLE[status];
    imageNode = SVGComponent;
  } else {
    var _EMPTY_STYLE2;
    // 默认noData
    var DefaultSVGComponent = (_EMPTY_STYLE2 = EMPTY_STYLE[realTheme]) === null || _EMPTY_STYLE2 === void 0 ? void 0 : _EMPTY_STYLE2['noData'];
    imageNode = DefaultSVGComponent;
  }
  return /*#__PURE__*/_jsxs("div", {
    style: style,
    className: cn(className, styles.molyEmpty, 'moly-empty', "moly-empty-".concat(size), "moly-empty-".concat(realTheme)),
    children: [/*#__PURE__*/_jsx("div", {
      className: cn("moly-empty-image"),
      style: imageStyle,
      children: imageNode
    }), title && /*#__PURE__*/_jsx("div", {
      className: cn("moly-empty-title", styles.molyTitle, EMPTY_STYLE.title[size]),
      children: title
    }), subTitle && /*#__PURE__*/_jsx("div", {
      className: cn("moly-empty-subtitle", styles.molySubTitle, EMPTY_STYLE.subTitle[size]),
      children: subTitle
    }), extra && /*#__PURE__*/_jsx("div", {
      className: cn('moly-empty-extra', EMPTY_STYLE.extra[size]),
      children: extra
    }), children && /*#__PURE__*/_jsx("div", {
      className: cn("moly-empty-content"),
      children: children
    })]
  });
};
export default Empty;